import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import departments from './departments';
import users from './users';
import pabxs from './pabxs';
import networksGroup from './networksGroup';
import devices from './devices';
import status from './status';
import expedients from './expedients';
import dashboards from './dashboards';
import recordPorts from './recordPorts';
import reportSchemas from './reportSchemas';
import reportContents from './reportContents';
import ivrs from './ivrs';
import authentications from './authentications';
import manufacturers from './manufacturers';
import categories from './categories';
import products from './products';
import services from './services';
import clients from './clients';
import species from './species';
import breeds from './breeds';
import pets from './pets';
import typeOccurrences from './typeOccurrences';
import occurrences from './occurrences';
import typeSchedules from './typeSchedules';
import schedules from './schedules';
import vaccines from './vaccines';
import veterinarians from './veterinarians';
import companies from './companies';
import permissionsGroup from './permissionsGroup';
import contactsHistory from './contactsHistory';
import codesNCM from './codesNCM';
import suppliers from './suppliers';

const reducers = {
  authentications,
  departments,
  companies,
  users,
  pabxs,
  networksGroup,
  devices,
  status,
  expedients,
  dashboards,
  recordPorts,
  reportSchemas,
  reportContents,
  ivrs,
  manufacturers,
  categories,
  products,
  services,
  clients,
  species,
  breeds,
  pets,
  typeOccurrences,
  occurrences,
  typeSchedules,
  schedules,
  vaccines,
  veterinarians,
  permissionsGroup,
  contactsHistory,
  codesNCM,
  suppliers
};

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    ...reducers
  });

export default createRootReducer;
